export default "__VITE_ASSET__CHMygIQM__"